import React from 'react';
import { Routes } from 'constants/pages';
import { Navigate } from 'react-router-dom';
import { RegionRedirect } from 'components/RegionRedirect';
import PlansAndBilling from './PlansAndBilling';
import Profile from './Profile';
import InvoiceHistory from './InvoiceHistory';
import NotificationSettings from './NotificationSettings';
import { TerminalCredentials } from './TerminalCredentials';

const settingsRoutes = () => {
  return [
    {
      path: Routes.Profile,
      element: <Profile />,
    },
    {
      path: Routes.Plans,
      element: <PlansAndBilling />,
    },
    {
      path: Routes.InvoiceHistory,
      element: <InvoiceHistory />,
    },
    {
      path: Routes.NotificationSettings,
      element: <RegionRedirect redirectTo={Routes.RegionalNotificationSettings} />,
    },
    {
      path: Routes.RegionalNotificationSettings,
      element: <NotificationSettings />,
    },
    {
      path: Routes.Credentials,
      element: <RegionRedirect redirectTo={Routes.RegionalCredentials} />,
    },
    {
      path: Routes.RegionalCredentials,
      element: <TerminalCredentials />,
    },
    {
      path: '*',
      element: <Navigate replace to={Routes.Profile} />,
    },
  ];
};

export default settingsRoutes;
